import React from 'react';
import { Linkedin, Mail, FileText } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { REOPEN_COOKIE_BANNER_EVENT } from './CookieConsentBanner';

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const openCookiePreferences = () => {
    window.dispatchEvent(new Event(REOPEN_COOKIE_BANNER_EVENT));
  };

  return (
    <footer className="bg-[#070B14] pt-20 pb-8 border-t border-[rgba(212,175,55,0.08)]">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-16">
          <div>
            <a href="#home" className="flex items-center gap-3">
              <img
                src="/logo-shield.png"
                alt="Pezente Digital"
                className="w-11 h-11 object-contain drop-shadow-[0_2px_12px_rgba(212,175,55,0.45)]"
              />
              <div className="flex flex-col leading-tight">
                <span className="font-serif text-xl light-text tracking-wide">PEZENTE</span>
                <span className="text-[10px] tracking-[0.35em] text-[#D4AF37] font-semibold">DIGITAL</span>
              </div>
            </a>
            <p className="text-[#9CA3AF] text-sm mt-6 leading-relaxed max-w-xs">{t.footer.tagline}</p>

            <div className="flex gap-3 mt-6">
              <a href="https://www.linkedin.com/company/pezente/" className="icon-box w-10 h-10 rounded-md flex items-center justify-center hover:scale-105 transition-transform">
                <Linkedin className="w-4 h-4" />
              </a>
              <a href="mailto:IAM@pezente.com" className="icon-box w-10 h-10 rounded-md flex items-center justify-center hover:scale-105 transition-transform">
                <Mail className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <p className="text-xs tracking-[0.3em] text-[#D4AF37] font-semibold mb-6">{t.footer.nav}</p>
            <ul className="space-y-3">
              <li><button onClick={() => scrollTo('home')} className="text-[#E8EAF0] text-sm hover:text-[#D4AF37] transition-colors">{t.footer.home}</button></li>
              <li><button onClick={() => scrollTo('about')} className="text-[#E8EAF0] text-sm hover:text-[#D4AF37] transition-colors">{t.footer.about}</button></li>
              <li><button onClick={() => scrollTo('contact')} className="text-[#E8EAF0] text-sm hover:text-[#D4AF37] transition-colors">{t.footer.contactLink}</button></li>
            </ul>
          </div>

          <div>
            <p className="text-xs tracking-[0.3em] text-[#D4AF37] font-semibold mb-6">{t.footer.contact}</p>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#D4AF37] mt-0.5 flex-shrink-0" />
                <a href="mailto:IAM@pezente.com" className="text-[#E8EAF0] text-sm hover:text-[#D4AF37] transition-colors break-all">
                  IAM@pezente.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-4 h-4 rounded-full border border-[#D4AF37] mt-0.5 flex-shrink-0 relative">
                  <span className="absolute inset-0.5 rounded-full bg-[#D4AF37]/40"></span>
                </span>
                <span className="text-[#E8EAF0] text-sm">{t.footer.advisory}</span>
              </li>
              <li className="flex items-start gap-3">
                <FileText className="w-4 h-4 text-[#D4AF37] mt-0.5 flex-shrink-0" />
                <a href="mailto:billing@pezente.com" className="text-[#E8EAF0] text-sm hover:text-[#D4AF37] transition-colors">
                  {t.footer.billing}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-[rgba(212,175,55,0.08)] flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#9CA3AF]">© {year} Pezente Digital. {t.footer.rights}</p>
          <div className="flex gap-6">
            <a href="/privacy-policy.html" target="_blank" rel="noopener noreferrer" className="text-xs text-[#9CA3AF] hover:text-[#D4AF37] transition-colors">{t.footer.privacy}</a>
            <a href="#" className="text-xs text-[#9CA3AF] hover:text-[#D4AF37] transition-colors">{t.footer.terms}</a>
            <button
              type="button"
              onClick={openCookiePreferences}
              className="text-xs text-[#9CA3AF] hover:text-[#D4AF37] transition-colors"
            >
              {t.footer.cookiePreferences}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
